import React, { useContext } from 'react'
import ConfigsContext from '../context/ConfigsContext';
import { BsFillArrowLeftCircleFill } from "react-icons/bs";
import {
  BsWhatsapp,
  BsFacebook,
  BsInstagram,
} from "react-icons/bs";

import logo from './../assets/logo.png';

const MenuViewer = () => {
  const {
    top,
    pageConfig,
    gallery,
    setGalleryPage,
    menu
  } = useContext(ConfigsContext);

  const { color } = pageConfig;
  const { link } = menu;

  const navigation = [
    {
      name: 'WhatsApp',
      href: 'https://api.whatsapp.com/send/?phone=5514997065191&text&type=phone_number&app_absent=0',
      icon: <BsWhatsapp />
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/armazemdvitto/',
      icon: <BsInstagram />
    },
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/ArmazemDVitto',
      icon: <BsFacebook />
    },
  ];
  
  return (
    <div style={ {backgroundColor: '#9999' } } className="h-screen">
      <header className="bg-gray1 fixed top-0 z-30 w-full flex flex-row justify-center items-center px-4 h-[5rem]">
        <div className="flex flex-row items-center justify-center">
          <a href="https://armazemdvitto.com.br">
            <img className="h-16 px-4 my-4 cursor-pointer" src={ top.logo } alt="Logo Armazém D'Vitto" />
          </a>
        </div>
        <nav className="flex flex-row w-24 md:w-32 justify-evenly">
          {navigation.map((item) => (
            <a key={item.name} href={item.href} className="text-white opacity-80 hover:opacity-100 hover:scale-125 ease-out duration-150 hover:text-white" target="_blank" rel="noreferrer">
              <span className="sr-only">{item.name}</span>
              {item.icon}
            </a>
          ))}
        </nav>
      </header>
      <section className="text-center h-[calc(100%-5rem)] fixed mt-[5rem]">
        <div className="flex flex-row items-center p-3 pb-0 h-[4rem]">
          <a href="https://armazemdvitto.com.br" className="top-18 right-4 py-4 pr-8">
            <BsFillArrowLeftCircleFill style={ { color: `${ color }`, stroke: 'rgba(153, 153, 153, 0.9)', strokeWidth: 0.5} } className="h-12 p-1 w-12 hover:scale-110 duration-150" />
          </a> 
          <h2 style={ { color: `${ color }`} } className="font-bold text-3xl text-left">Nosso Cardápio</h2>
        </div>
        <div className="w-screen p-3 h-[calc(100%-4rem)] flex flex-col md:flex-row md:overflow-x-auto">
          {/* <iframe
            type="application/pdf"
            scrolling="auto"
            src={`https://docs.google.com/viewer?embedded=true&url=${encodeURIComponent(link)}`}
            className="w-full h-full">
          </iframe> */}
          {/* <object 
            type="application/pdf" 
            data={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(link)}`} 
            className="w-full h-full">
          </object> */}
          <iframe 
            type="application/pdf"
            src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(link)}`}
            className="w-full h-full"
            frameBorder={`0`}>
          </iframe>
          {/* <iframe
            type="application/pdf"
            scrolling="auto"
            src={`https://drive.google.com/viewerng/viewer?embedded=true&url=${encodeURIComponent(link)}`}
            className="w-full h-full">
          </iframe> */}
        </div>
      </section>
    </div>

  )
}

export default MenuViewer;
